import { useState } from 'react'
import DrawerUserMenu from './DrawerUserMenu'
import ModalNewConnnection from '../newConnection/ModalNewConnnection'
import UserAvatar from './UserAvatar'
import { useSelector } from 'react-redux'
import { RootState } from '../../store/store'
import { hasRoleAccess, RolesType } from '../../utils/roles'

const UserMenu = ({ roles }: { roles: RolesType | undefined }) => {

    const { service_id } = useSelector((state: RootState) => state.contract)

    const [isOpenModal, setIsOpenModal] = useState<boolean>(false)
    const [isOpenDrawer, setIsOpenDrawer] = useState<boolean>(false)

    const handleCloseDrawer = () => {
        setIsOpenDrawer(false)
    }
    const handleOpenDrawer = () => {
        setIsOpenDrawer(true)
    }
    const handleCloseModal = () => {
        setIsOpenModal(false)
    }
    const handleOpenModal = () => {
        setIsOpenDrawer(false)
        setIsOpenModal(true)
    }

    return (
        <div>
            <ModalNewConnnection
                open={isOpenModal}
                handleClose={handleCloseModal}
                currentServiceId={service_id === 1 ? 2 : 1}
            />
            <DrawerUserMenu
                roles={roles}
                open={isOpenDrawer}
                handleClose={handleCloseDrawer}
                handleNewConnection={handleOpenModal}
            />
            <UserAvatar handleOpenDrawer={handleOpenDrawer} />
        </div>
    )
}

export default UserMenu